import { useNavigate } from "react-router-dom";
import { TicketIcon } from "../../../../assets/icons";
import styles from "./confirmBillOrder.module.scss";
import { ApplicationRoutes } from "../../../../routes";
interface IProps {
	amount: string;
	totalAmount: string;
	onConfirmOrder: () => void;
}
const ConfirmBillOrder = ({ amount, totalAmount, onConfirmOrder }: IProps) => {
	const navigate = useNavigate();
	return (
		<div className={styles.container}>
			<div className={styles.innerContainer}>
				<div className={`${styles.innerContainer} ${styles.marginBottom}`}>
					<h2 className={styles.title}>Order Summary</h2>
				</div>
				<div className={styles.priceInfo}>
					<div className={`${styles.box} ${styles.upper}`}>
						<span className={styles.text}>Item’s Total</span>
						<span className={`${styles.text} ${styles.normalValue}`}>₦{amount}</span>
					</div>
					<div className={styles.box}>
						<span className={`${styles.text} ${styles.total}`}>Total</span>
						<span className={`${styles.text} ${styles.totalValue}`}>₦{totalAmount}</span>
					</div>
				</div>
				<div className={styles.infoBox}>
					<div className={styles.orangeBox}>
						<TicketIcon />
					</div>
					<p className={`${styles.text} ${styles.small}`}>You will be able to add a voucher when selecting your payment method.</p>
				</div>
				<div className={styles.buttonContainer}>
					<button className={styles.button} onClick={onConfirmOrder}>
						Confirm Order
					</button>
				</div>
			</div>
			<div>
				<p className={styles.terms}>
					By Proceeding, you are automatically accepting the <br />
					<span style={{ cursor: "pointer" }} onClick={() => navigate(`/${ApplicationRoutes.TERMS}`)}>
						Terms & Conditions
					</span>
				</p>
			</div>
		</div>
	);
};

export default ConfirmBillOrder;
